/**
 * Detects IE11
 * Taken from https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
 * @type {Boolean}
 */
const isInternetExplorer = !!window.MSInputMethodContext && !!document.documentMode;

export default isInternetExplorer;
